// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 11.97 18'
    ...attributes
  ><path
      fill='var(--icon-color, #000)'
      d='M5.668 14.848A3.15 3.15 0 1 1 8.816 18a3.15 3.15 0 0 1-3.148-3.152m2.248-3.633v-.9c0-.217-.066-.3-.137-.348a.5.5 0 0 0-.283-.1c-.118 0-.344 0-.622-.006-.772 0-2.069 0-2.417.006h-.024a2.32 2.32 0 0 1-1.579-.656 2.13 2.13 0 0 1-.631-1.551v-.9h1.8v.9a.35.35 0 0 0 .095.27.54.54 0 0 0 .311.137c.363-.006 1.616-.006 2.441-.006.278.006.5.006.622.006a2.32 2.32 0 0 1 1.38.477 2.17 2.17 0 0 1 .839 1.775v.9zM-.001 3.149a3.15 3.15 0 1 1 3.148 3.15A3.15 3.15 0 0 1 0 3.148zm1.8 0a1.35 1.35 0 1 0 1.348-1.35A1.355 1.355 0 0 0 1.8 3.148z'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'IconInherit';
export default IconComponent;
